export const answersVariants = {
  noAnswer: 0,
  correct: 1,
  incorrect: 2,
  rightAnswer: 3,
  nothing: 9
}